import React from "react";
import { Trans } from "app/utils";

interface CameraCountdownProps {
  countdown?: number;
}

const CameraCountdown: React.FC<CameraCountdownProps> = ({
  countdown
}) => (
  <h1 className="Video-Top_Info-Effects">
    <Trans>Recording in</Trans>
    <br />
    <span className="Video-Top_Info-Effects--Counter">{countdown}</span>
  </h1>
);

export default CameraCountdown;
